<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3.33301 13.3333H12.6663M1.33301 2.66663L3.33301 10.6666H12.6663L14.6663 2.66663L10.6663 7.33329L7.99967 2.66663L5.33301 7.33329L1.33301 2.66663Z"
            stroke="url(#paint0_linear_1203_482)"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <defs>
            <linearGradient
                id="paint0_linear_1203_482"
                x1="1"
                y1="1.99988"
                x2="10.1362"
                y2="14.5625"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FF8D47" />
                <stop offset="0.329612" stop-color="#FF8947" />
                <stop offset="0.534043" stop-color="#FF4247" />
                <stop offset="0.68692" stop-color="#E92A5B" />
                <stop offset="0.828171" stop-color="#DD1C67" />
                <stop offset="1" stop-color="#CF0283" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
